import React from "react";
import { Box, Theme, Typography, alpha } from "@mui/material";

interface StatusBadgeProps {
  status: "on-shift" | "on-break" | "off-shift";
  label: string;
  "data-testid"?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label, "data-testid": dataTestId }) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case "on-shift":
        return {
          color: "success.main",
        };
      case "on-break":
        return {
          color: "warning.main",
        };
      case "off-shift":
        return {
          color: "grey.500",
        };
      default:
        return {
          color: "grey.500",
        };
    }
  };

  const config = getStatusConfig(status);
  const shouldPulse = status === "on-break";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
      }}
      data-testid={dataTestId}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: config.color,
          flexShrink: 0,
          ...(shouldPulse && {
            animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            "@keyframes pulse": {
              "0%, 100%": {
                opacity: 1,
              },
              "50%": {
                opacity: 0.5,
              },
            },
          }),
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: config.color,
          fontWeight: 700,
          fontSize: "0.75rem",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          lineHeight: 1,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StatusBadge;
